var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.allNull ? "创建APP" : "编辑APP",
        visible: _vm.dialogVisible,
        width: "596px",
        "before-close": _vm.handleClose,
        "custom-class": "dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.formInfo,
            rules: _vm.rules,
            "label-width": "134px",
            "label-position": "right",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "应用名称", prop: "appName" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入应用名称",
                  maxlength: "10",
                  clearable: "",
                },
                model: {
                  value: _vm.formInfo.appName,
                  callback: function ($$v) {
                    _vm.$set(_vm.formInfo, "appName", $$v)
                  },
                  expression: "formInfo.appName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Android 应用包名", prop: "androidAppName" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入Android 应用包名",
                  maxlength: "64",
                  clearable: "",
                },
                model: {
                  value: _vm.formInfo.androidAppName,
                  callback: function ($$v) {
                    _vm.$set(_vm.formInfo, "androidAppName", $$v)
                  },
                  expression: "formInfo.androidAppName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "IOS 应用包名", prop: "iosAppName" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入IOS 应用包名",
                  clearable: "",
                  maxlength: "64",
                },
                model: {
                  value: _vm.formInfo.iosAppName,
                  callback: function ($$v) {
                    _vm.$set(_vm.formInfo, "iosAppName", $$v)
                  },
                  expression: "formInfo.iosAppName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "14" }, on: { click: _vm.handleClose } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "14" },
              on: { click: _vm.onSubmit },
            },
            [_vm._v("保存\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }